var _circle, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAttachmentDownload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fillRule: "evenodd",
    clipRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.205 12.615L12 16.82l-4.205-4.205.773-.773 2.885 2.885V5h1.094v9.727l2.885-2.885.773.773zM19 17.906H5V19h14v-1.094z",
    fill: "#425ef2",
    fillRule: "nonzero"
  })));
}

export default __webpack_public_path__ + "./fonts/attachment-download.695f23005b13d214f7946eb55df07194.svg";
export { SvgAttachmentDownload as ReactComponent };